module.exports = __webpack_public_path__ + "img/tp-link_pic3.c10b840d.png";